import React from 'react';
import RestCreate from 'containers/rest/Create';
import Form from '../components/Form';
import { omit } from 'lodash';
import { getDataDetail } from 'utils/tools';

const breadcrumbs = [
  {
    title: 'common.page.transferOrders',
    href: '/transfer-orders',
  },
  {
    title: 'common.page.create',
  },
];

const CreateTransfer = () => {
  return (
    <RestCreate
      model="transferOrders"
      breadcrumbs={breadcrumbs}
      hasSelectFilter={false}
      formatOnSubmit={(values) => {
        return {
          ...omit(values, ['orderSelected', 'variantsApplied']),
          items: values.variantsApplied.map((item) => ({
            variantSku: item?.variantSku,
            variantName: getDataDetail(item?.product)?.name,
            quantity: item?.quantityEdited,
          })),
        };
      }}
      customPathAfterSubmit="transfer-orders"
      apiOptions={{
        isShowSuccessNoti: true,
      }}
    >
      <Form />
    </RestCreate>
  );
};

export default CreateTransfer;
